<div class="container-fluid mt-4">
    <div class="row">
     
        <div class="col-md-12">
            <div class="card p-3 shadow-sm">
                <h5 class="text-center">Formulaire de décision</h5>
                <form (ngSubmit)="onSubmit()">

                    <!-- Sélection de la décision -->
                    <div class="mb-3">
                        <label for="decision" class="form-label">Choisir une action *</label>
                        <select id="decision" class="form-select" [(ngModel)]="itemToSave.statut" name="statut">
                            <option value="" disabled selected>-- Sélectionner une action --</option>
                            <option value="validate">✅ Valider</option>
                            <option value="invalidate">❌ Rejeter</option>
                        </select>
                     
                    </div>
                    <div class="mb-3">
                        <!-- <label for="decision" class="form-label">Cloturer? *</label>
                        <select id="decision" class="form-select" [(ngModel)]="itemToSave.statut" name="statut">
                            <option value="" disabled selected>-- Sélectionner une action --</option>
                            <option value="validate">✅ Oui</option>
                            <option value="invalidate">❌ Non</option>
                        </select> -->
                        <label for="break_circuit" class="form-label">
                            <input [(ngModel)]="itemToSave.break_circuit" type="checkbox" name="break_circuit" id="break_circuit">
                            Cloturer?</label>
                        
                     
                    </div>

                    <!-- Champ texte pour la raison -->
                    <div class="mb-3">
                        <label for="commentaire" class="form-label">Raison (Optionnel)</label>
                        <textarea [(ngModel)]="itemToSave.commentaire" name="commentaire" id="commentaire" class="form-control" rows="3" ></textarea>
                    </div>

                    <!-- Bouton de soumission -->
                    <button type="submit" class="btn btn-primary w-100" (click)="onSubmit()">Soumettre</button>
                </form>
            </div>
        </div>
    </div>
</div>